import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes } from '../CalendarSummary.st.css';
import { BookingDetailsDataHooks } from '../../constants';

export interface PriceWithDiscountProps {
  originalPrice: string;
  priceAfterDiscount: string;
}

export const PriceWithDiscount: React.FC<PriceWithDiscountProps> = ({
  originalPrice,
  priceAfterDiscount,
}) => (
  <div className={classes.priceRow}>
    <Text
      data-hook={BookingDetailsDataHooks.SLOT_PLAN_TYPE}
      className={classes.priceBeforeDiscount}
    >
      {originalPrice}
    </Text>
    <Text
      data-hook={BookingDetailsDataHooks.PRICE_AFTER_DISCOUNT}
      className={classes.commonTextStyle}
    >
      {priceAfterDiscount}
    </Text>
  </div>
);
